module.exports = "/images/ico-mc.svg?d650b476bbbda15b04dd45c4b40b8795";